import React, {
    Fragment,
    useContext, useState,
} from 'react';
import { createPortal } from 'react-dom';
import Tippy from '@tippyjs/react';

import { PageStateContext } from '../../context/PageStateContext';

import {
    getDraftUrl,
    getTeamUrl,
    getPageUrlFromPageId,
} from '../../utilities/urlHelper';

const CloseDraftModal = (props) => {
    const { pageState } = useContext(PageStateContext);
    const { draft, isSuggestEdit } = pageState || {};
    const displayText = isSuggestEdit ? 'suggestion' : 'draft';
    const isDisabled = !(draft && draft.id);
    const saveUrl = draft && draft.page_id
        ? getPageUrlFromPageId(draft.page_id)
        : getTeamUrl();
    const discardUrl = `${getDraftUrl(draft && draft.id)}?redirectUrl=${saveUrl}`;

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return props.closeModal();
        }
    };

    return (
        <div className="react-modal open close-draft-modal" onMouseDown={onClickModal}>
            <div className="modal-content">
                <button
                    className="flex-none btn ml1 silver rounded h4 right"
                    style={{ margin: '-15px' }}
                    aria-label="close modal"
                    onClick={props.closeModal}
                >
                    <span aria-hidden="true">×</span>
                </button>
                <h2>{`Discard ${displayText}?`}</h2>
                <div>
                    <p>What should we do with your changes?</p>
                </div>
                <div className="mt2 right-align">
                    <a href={saveUrl} className="btn-secondary mr1 react-modal-close">Save and close</a>
                    <form method="POST" action={discardUrl} acceptCharset="UTF-8" className="right">
                        <input name="_token" type="hidden" value={window.csrfToken} />
                        <input type="hidden" name="_method" value="delete" />
                        <input id="delete-button" className="btn btn-primary bg-red" type="submit" value={`Discard ${displayText}`} disabled={isDisabled} />
                    </form>
                </div>
            </div>
        </div>
    );
};

const DraftClose = (props) => {
    const [showModal, setShowModal] = useState();
    const displayText = props.isSuggestEdit ? 'suggestion' : 'draft';

    return (
        <Fragment>
            <Tippy content={`Close ${displayText}`} placement="bottom">
                <button
                    className="flex-none btn ml1 silver rounded"
                    onClick={() => setShowModal(true)}
                    aria-label="close draft"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </Tippy>

            { showModal && createPortal(<CloseDraftModal
                closeModal={() => setShowModal(false)}
                forceRedirect
            />, document.body) }
        </Fragment>
    );
};

export default DraftClose;
